<template>
  <v-menu v-if="menu" :close-on-content-click="false">
    <template v-slot:activator="{ props }">
      <v-btn
        :flat="!activeFilterCount"
        variant="outlined"
        v-bind="props"
        class="mr-2 text-primary bg-white"
        data-pw="toolbarButtons"
        :color="activeFilterCount ? 'green': ''"
      >
        <v-icon v-if="icon" color="mr-2">{{ icon }}</v-icon>
        <span>{{ label }}</span>
        <v-chip v-if="activeFilterCount > 0"
                size="x-smallZ"
                class="py-1 px-2 white rounded black--text ml-1"
                :color="activeFilterCount ? 'primary': 'secondary'">
          {{ activeFilterCount }}
        </v-chip>
      </v-btn>
      <v-btn
        v-if="activeFilterCount"
        variant="outlined"
        class="mr-2"
        data-pw="toolbarButtons"
        color="red"
        @click="$emit('resetFilter')"
      >
        {{ $t("buttons.reset") }}
      </v-btn>
    </template>
    <v-card min-width="200px" rounded variant="outlined" class="mt-1">
      <v-list density="compact">
        <slot/>
      </v-list>
    </v-card>
  </v-menu>
  <v-btn v-else
         :flat="!activeFilterCount"
         variant='outlined'
         class="mr-2 text-primary"
         data-pw="toolbarButtons"
         :color="activeFilterCount ? 'green': ''"
         @click="$emit('toggleFilterTable')"
         :style="{ 'min-width': '160px' }"
  >
    <v-icon v-if="icon" color="mr-2">{{ icon }}</v-icon>
    <span>{{ label }}</span>
    <v-chip v-if="activeFilterCount > 0"
            size="x-small"
            class="py-1 px-2 white rounded black--text ml-1"
            :color="activeFilterCount ? 'primary': 'secondary'">
      {{ activeFilterCount }}
    </v-chip>
  </v-btn>
</template>

<script setup lang="ts">
import { PropType } from "vue";

defineProps({
  label: {
    type: String as PropType<string>,
    required: true
  },
  icon: {
    type: String as PropType<string>
  },
  activeFilterCount: {
    type: Number as PropType<number>,
    default: 0
  },
  menu: {
    type: Boolean as PropType<boolean>,
    default: true
  }
});
</script>
